module.exports = __webpack_public_path__ + "img/cian_traynor.de8d49b6.jpg";